module.exports = import("https://unpkg.com/lightweight-charts@4.1.1/dist/lightweight-charts.esm.production.js");;